const theme = {
	primaryColor: '#3e4c57',
	primaryHover: '#293843',
	activeColor: '#f9cb37',
	inactiveColor: '#cdcdcd',
	errorColor: '#dd5860',
	darkbgColor: '#f4f4f4',
	fieldLabelColor: '#686868',
	greenColor: '#3cb950',
	warningColor: '#ffcc00',

	formIdent: '18px',
	formColWidth: '300px',
	formCoNarrowlWidth: '140px',
	formColGap: '45px',
	contentMaxWidth: '1920px',
	sectionColWidth: { // Including col paddings
		wide: '470px',
		normal: '340px'
	},
	sectionColPadding: '10px',
	navBarHeight: {
		mainSections: '77px',
		bottomNav: '48px',
		default: '36px'
	},
	contentHeaderHeight: '22px'
}

export default theme
